// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  dtmi: __t.string(),
  dofName: __t.string(),
  sourceKind: __t.string(),
  sourceName: __t.string(),
  constantValue: __t.f64(),
  kind: __t.string(),
  inMin: __t.f64(),
  inMax: __t.f64(),
  outMin: __t.f64(),
  outMax: __t.f64(),
  transitionSeconds: __t.f64(),
  idleTimeoutSeconds: __t.f64(),
};
